import type { ReactNode } from 'react';
import { SiteHeader } from '../../app/SiteHeader';

/** #885: the public pages' frame. #959: under the same header bar as every other page. */
export function PublicLayout({ children }: { readonly children: ReactNode }) {
  return (
    <div className="public-page">
      <SiteHeader />
      <main className="public-main">{children}</main>
    </div>
  );
}
